import React from 'react';

export const ProjectCoshhContext = React.createContext({});

export const useProjectCoshhContext = () =>
  React.useContext(ProjectCoshhContext);
